/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { BEM } from "@adapptio/lib-components";
import { ThemeModel } from "../../../Common/ThemeModel";
import { isSelectionItemBlock } from "../../../Common/ThemeEditSelection";
import { ThemeEditorMainBlock } from "./ThemeEditorMainBlock";
import { useStateWithEvent } from "../../../../../ui/hooks";
import { isSchemaConstObjectModel, isSchemaConstStringModel } from "@adapptio/lib-blueprint";
import { ThemeEditorMainDefault } from "./ThemeEditorMainDefault";

export interface IThemeEditorMainProps {
	className?: string;
	themeModel: ThemeModel;
}

export const ThemeEditorMain: React.FC<IThemeEditorMainProps> = ({ className, themeModel }) => {
	const baseClass = BEM("edt-theme-editor-main");

	const selection = useMemo(() => themeModel.getSelection(), [ themeModel ]);
	const selectedItem = useStateWithEvent(selection.onChange, () => selection.getItems()[0]);

	if (className) {
		baseClass.add(className);
	}

	if (isSelectionItemBlock(selectedItem)) {
		const modelNode = themeModel.getDesignContext().getNodeById(selectedItem.nodeId);

		if (isSchemaConstObjectModel(modelNode) && isSchemaConstStringModel(modelNode.props.content)) {
			return <ThemeEditorMainBlock contentModel={modelNode.props.content} />;
		}
	}

	return <ThemeEditorMainDefault />;
};
